import classNames from 'classnames';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import './about.less';
import './static_page.less';
import {Link} from 'react-router';
import Header from '../header/header';
import Footer from '../footer/footer';

import DashBoardHeader from '../header_dashboard/dashboard_header';
import cookies from '../util/cookie';
import authActions from '../auth/auth_actions';

class About extends React.Component {

  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  render(){

    const {state, props} = this;
    let homePage;
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isSessionValid = false;

    if('userData' in props.authState){
      isSessionValid  = props.authState.userData.sessionValid
    }

    if(isSessionValid && props.authState){
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
    }


    return(
      <div className="static-page about-us-page">
        {!isSessionValid && <Header isFixedHeader={true} /> }
        {isSessionValid &&  <DashBoardHeader user = {user} logout={this.logout} /> }
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <h1 className = "static-header">About Us</h1>
        </div>
        <div className = "static-page-wrapper">
          <div className = "content-wrap">
            <div className="static-content">AirWayBill is a new way to get an old job done—moving a package from one person to another. We do it by matching shippers with travelers who are willing to share some extra space in their suitcase to deliver an item more quickly and cheaply than a conventional courier service can. We help family members on different continents stay connected—whether it’s delivering hard-to-get medicine or a new laptop that is too expensive to buy back home.  We also connect consumers with carriers who will act as their personal shoppers and bring them goods that are hard to get in their home countries. Carriers earn money to help pay for travel costs, while doing a good deed, too.  Shoppers and families get the items they want. Everybody wins. </div>
            <div className="static-content">Khaled Sehly and his co-founders got the idea for AirWayBill from their experiences as international business travelers. When they passed through airports in the Middle East and India, and other parts of the world they saw people asking strangers to carry a package or an important document to a relative or business associate in another country. The founders also saw how their friends and family ask to bring something from abroad on social media. They also wanted to help students and professionals living abroad visit home more frequently and pay less for their travel. And they knew that another group of global consumers-- highly sophisticated trendsetters--would pay a sizable premium to get the next smartphone delivered to them before it hit stores in their home countries. </div>
            <div className="static-content">AirWayBill, peer-to-peer shipping platform was born and the app went live in early 2017. AirWayBill, S.L. is incorporated and headquartered in Spain and falls under strict EU regulations. The development of the app and platform was done in Silicon Valley by the best programmers in the business to ensure that users have the easiest customer experience and can count on accurate, error-free transactions every time. </div>
              <div className="static-content">The team who took this idea into the real world are:  </div>
            <div className="static-content"><span className = "bold-text">Hazzaa S. AlShareef, </span>a business executive from Saudi Arabia, serves as AirWayBill’s President.</div>
            <div className="static-content"><span className = "bold-text">Khaled Sehly, </span>a veteran pharmaceuticals marketing executive, serves as AirWayBill’s Managing Director.</div>
            <div className="static-content">Three top executives leading operation, strategy and communication hail from Spain, Egypt, and Saudi Arabia.</div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions : bindActionCreators(authActions, dispatch)
  }
}

About = connect(
  mapStateToProps,
  mapDispatchToProps
)(About)

export default About;



// WEBPACK FOOTER //
// app/static_pages/about.jsx